import { defineStore } from 'pinia';
import { DATA_SOURCE } from '@/config';

export const useDataSourceStore = defineStore('dataSource', {
  state: () => ({ mode: DATA_SOURCE, revision: 0 }),
  getters: {
    isMock: state => state.mode === 'mock',
  },
  actions: {
    setMode(mode) {
      if (!['db', 'mock'].includes(mode)) throw new TypeError('Unknown data source');
      if (this.mode === mode) return;
      this.mode = mode;
      this.revision++;
    },
  },
});
